import { render, staticRenderFns } from "./pedidos-criar.vue?vue&type=template&id=35b9293c"
import script from "./pedidos-criar.vue?vue&type=script&lang=js"
export * from "./pedidos-criar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports